// extracted by mini-css-extract-plugin
module.exports = {"root":"SearchAdminTrainers_root__2RF8G","table":"SearchAdminTrainers_table__24FBE"};